/** Limbile în care există interfața.
 *
 *  Lista asta e contractul: o limbă e aici DOAR dacă are catalog complet în
 *  `i18n/<cod>.ts`. Codul `Catalog` din `ro.ts` face completitudinea o condiție
 *  de COMPILARE, nu o promisiune — un catalog căruia îi lipsește o cheie nu
 *  trece de `tsc`.
 *
 *  `bcp47` e eticheta cu care se cheamă `Intl`: ea decide separatorul zecimal,
 *  ordinea din dată și numele lunilor. Engleza e `en-GB`, nu `en-US` — produsul
 *  e metric și european, iar `1/12` trebuie să însemne 1 decembrie și în
 *  engleză, ca în desenele pe care le citește aceeași echipă.
 */

export const LIMBI = [
  { cod: "ro", bcp47: "ro-RO", nume: "Română", englezesc: "Romanian" },
  { cod: "en", bcp47: "en-GB", nume: "English", englezesc: "English" },
] as const;

export type Limba = (typeof LIMBI)[number]["cod"];

/** Limba în care e scrisă platforma: pe ea cade orice cont fără alegere. */
export const LIMBA_IMPLICITA: Limba = "ro";

export function esteLimba(x: unknown): x is Limba {
  return typeof x === "string" && LIMBI.some((l) => l.cod === x);
}

export function bcp47(limba: Limba): string {
  return LIMBI.find((l) => l.cod === limba)?.bcp47 ?? "ro-RO";
}

/** Ce limbă îi arătăm cuiva care încă n-a intrat în cont.
 *
 *  Ecranul de login se desenează înainte ca `/api/auth/me` să răspundă, deci
 *  acolo nu există încă un profil. Se ia ultima limbă folosită pe aparatul ăsta
 *  (scrisă la login), iar la prima vizită se citește limba browserului. Alegerea
 *  din profil o înlocuiește imediat ce sesiunea răspunde.
 */
export const CHEIE_STOCARE = "ob.limba";

export function limbaDeStart(): Limba {
  try {
    const salvata = localStorage.getItem(CHEIE_STOCARE);
    if (esteLimba(salvata)) return salvata;
  } catch {
    // Un browser cu stocarea blocată nu e un motiv de ecran alb.
  }
  for (const preferata of navigator.languages ?? [navigator.language]) {
    const cod = (preferata ?? "").slice(0, 2).toLowerCase();
    if (esteLimba(cod)) return cod;
  }
  return LIMBA_IMPLICITA;
}
